import { flatMap } from 'lodash';

export type Index = Exclude<keyof any, symbol>;

export function groupByList<T>(
  list: T[],
  getIds: (entity: T) => Index[],
): Partial<Record<Index, T[]>> {
  return flatMap(list, (entity): [Index, T][] =>
    getIds(entity).map((id) => [id, entity]),
  ).reduce<Partial<Record<Index, T[]>>>(
    (acc, [id, el]) => ({
      ...acc,
      [id]: [...(acc[id] || []), el],
    }),
    {},
  );
}
